<template>
  <v-layout>
    <v-flex>
      <div class="appPerils mt-2">
        Protect Against:
        <br />
        {{ perilNames.join(' • ') }}
        <v-tooltip top>
          <v-flex class="tooltipWrapper">
            <span class="pb-2">All Covered Reasons:</span>
            <v-layout>
              <v-flex column wrap xs5 pa-2>
                <ul>
                  <li v-for="perilName in perilNames" v-bind:key="perilName">
                    {{ perilName }}
                  </li>
                </ul>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-tooltip>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
  name: 'ThePerils',
  props: {
    underwriter: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters(['urlParams']),
    ...mapGetters('widgetData', ['widgetData']),
    perilNames() {
      if (this.widgetData && this.widgetData.perils) {
        return this.widgetData.perils.map(peril => peril.name);
      }
      return [];
    },
  },
  watch: {
  },
};
</script>

<style scoped>
.appPerils {
  font-family: Gotham;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
  padding-top: 30px;
}

.appPerilsAndMoreText {
  font-family: Gotham;
  font-size: 16px;
  color: #31b0e5;
}

.tooltipWrapper {
  width: auto;
}

/* Tablet Break Point */
@media screen and (max-width: 1264px) {
  .appPerils {
    width: 608px;
    margin: 0 auto;
  }

  .tooltipWrapper {
    width: auto;
  }
}

/* Mobile Break Point */
@media screen and (max-width: 767px) {
  .appPerils {
    width: 271px;
    margin: 0 auto;
  }

  .tooltipWrapper {
    width: auto;
  }
}

/* Mobile Break Point Larger */
@media screen and (min-width: 375px) and (max-width: 767px) {
  .appPerils {
    width: 317px;
    margin: 0 auto;
    padding-top: 35px;
  }
}
</style>
